import { render, staticRenderFns } from "./Widget10.vue?vue&type=template&id=d3ae5b52"
import script from "./Widget10.vue?vue&type=script&lang=js"
export * from "./Widget10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports